import { render } from "./Birthdate.vue?vue&type=template&id=65c47e9b&scoped=true&ts=true&lang=pug"
import script from "./Birthdate.vue?vue&type=script&lang=ts"
export * from "./Birthdate.vue?vue&type=script&lang=ts"

import "./Birthdate.vue?vue&type=style&index=0&id=65c47e9b&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Birthdate.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/common/birthdate.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fcommon%2FBirthdate.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c47e9b"]])

export default __exports__